import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';

export default function SimpleModal({ open, onClose, title, bodyText, body, children }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {title && (
        <DialogTitle id="alert-dialog-title" style={{ padding: '12px' }}>
          {title}
        </DialogTitle>
      )}
      {bodyText && (
        <DialogContent style={{ padding: '0 12px 12px 12px' }}>
          <DialogContentText id="alert-dialog-description">
            {bodyText}
          </DialogContentText>
        </DialogContent>
      )}
      {body}
      {children && (
        <DialogActions style={{ display: 'flex', justifyContent: 'space-between', padding: '0 12px 12px 12px', margin: 0 }}>
          {children}
        </DialogActions>
      )}
    </Dialog>
  );
}
